module.exports = __webpack_public_path__ + "img/officer.8e0a71d1.png";